import { render, staticRenderFns } from "./LogoImg.vue?vue&type=template&id=4ec53116&scoped=true"
import script from "./LogoImg.vue?vue&type=script&lang=js"
export * from "./LogoImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec53116",
  null
  
)

export default component.exports